module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "header",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "flexbetween"
  }, [_c('div', [_c('a', {
    staticClass: "rslogo",
    on: {
      "click": function($event) {
        return _vm.clickLogo()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/icon/header/logo.png"
    }
  })])]), _vm._v(" "), (!_vm.isDocomo(_vm.platformName) && !_vm.isAu(_vm.platformName)) ? _c('div', {
    staticClass: "contentname lbold font32"
  }, [_vm._v(_vm._s(_vm.viewName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "item setting-help"
  }, [_c('popover', {
    attrs: {
      "name": "help",
      "closeOnContentClick": true
    }
  }, [_c('div', {
    staticClass: "btn-help",
    attrs: {
      "slot": "face"
    },
    on: {
      "click": function($event) {
        return _vm.updateMenu()
      }
    },
    slot: "face"
  }, [_c('img', {
    attrs: {
      "src": "static/images/icon/header/help.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "help-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.isDocomo(_vm.platformName) || _vm.isAu(_vm.platformName)) ? _c('ul', [_c('li', {
    staticClass: "docomo_push"
  }, [_c('div', [_c('span', [_vm._v("プッシュ通知を許可")]), _c('span', {
    staticClass: "push_option",
    class: {
      active: _vm.isPushEnabled
    },
    on: {
      "click": _vm.showPushSetting
    }
  }, [_vm._v("ON")]), _c('span', {
    staticClass: "push_option",
    class: {
      active: !_vm.isPushEnabled
    },
    on: {
      "click": _vm.showPushSetting
    }
  }, [_vm._v("OFF")])]), _vm._v(" "), (_vm.isDocomo(_vm.platformName)) ? _c('div', {
    staticClass: "font14 lbold ml10 mt10"
  }, [_vm._v("月に1~3回程度アップデート案内します。")]) : _vm._e(), _vm._v(" "), (_vm.isDocomo(_vm.platformName)) ? _c('div', {
    staticClass: "font14 ml10"
  }, [_c('span', [_vm._v("らくらくスマートフォン等の非対応機種では配信されません。")])]) : _vm._e()]), _vm._v(" "), (_vm.isDocomo(_vm.platformName)) ? _c('li', {
    on: {
      "click": _vm.showPrivacyPolicy
    }
  }, [_vm._v("プライバシーポリシー")]) : _vm._e(), _vm._v(" "), (_vm.isAu(_vm.platformName)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.showTakeOver()
      }
    }
  }, [_vm._v("引継ぎコード発行")]) : _vm._e(), _vm._v(" "), (_vm.isAu(_vm.platformName)) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.getContactUrl(),
      "target": "_blank"
    }
  }, [_vm._v("お問い合わせ")])]) : _vm._e(), _vm._v(" "), (_vm.isAu(_vm.platformName)) ? _c('li', [_c('a', {
    attrs: {
      "href": "http://www.sourcenext.com/r/p/au/rosetta_us/support/",
      "target": "_blank"
    }
  }, [_vm._v("FAQ")])]) : _vm._e(), _vm._v(" "), (_vm.isAu(_vm.platformName)) ? _c('li', [_c('a', {
    attrs: {
      "href": "http://www.sourcenext.com/r/p/au/rosetta_us/product/",
      "target": "_blank"
    }
  }, [_vm._v("製品紹介")])]) : _vm._e(), _vm._v(" "), (_vm.currentView != 'PortalList' && _vm.currentView != 'AuPortalList') ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.clickLogo()
      }
    }
  }, [_vm._v("戻る")]) : _vm._e()]) : _c('ul', [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPlatformiOS(_vm.platformName)),
      expression: "!isPlatformiOS(platformName)"
    }]
  }, [_c('a', {
    staticClass: "logout-btn",
    on: {
      "click": function($event) {
        return _vm.showLogout()
      }
    }
  }, [_vm._v("ログアウト")])]), _vm._v(" "), (_vm.isPushSetting) ? _c('li', {
    staticClass: "docomo_push"
  }, [_c('div', [_c('span', [_vm._v("プッシュ通知を許可")]), _c('span', {
    staticClass: "push_option",
    class: {
      active: _vm.isPushEnabled
    },
    on: {
      "click": _vm.showPushSetting
    }
  }, [_vm._v("ON")]), _c('span', {
    staticClass: "push_option",
    class: {
      active: !_vm.isPushEnabled
    },
    on: {
      "click": _vm.showPushSetting
    }
  }, [_vm._v("OFF")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.sendGaEventHelpClick(_vm.constants.GA_EVENT.LABEL.SUPPORT)
      }
    }
  }, [_c('a', {
    staticClass: "helptext",
    attrs: {
      "href": "http://www.sourcenext.com/support/t/p/?c=19e4d5e1-c20d-4665-90c5-8e47ed771d46",
      "target": "_blank"
    }
  }, [_vm._v("サポート")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "readme",
    attrs: {
      "href": "https://www.sourcenext.com/r/p/rosettastone/eula/",
      "target": "_blank"
    }
  }, [_vm._v("Rosetta Stone について")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPlatformiOS(_vm.platformName)),
      expression: "isPlatformiOS(platformName)"
    }],
    on: {
      "click": function($event) {
        return _vm.doRestoreContent()
      }
    }
  }, [_c('a', [_vm._v("購入を復元する")])]), _vm._v(" "), (!_vm.isRegistered) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPlatformiOS(_vm.platformName)),
      expression: "isPlatformiOS(platformName)"
    }],
    on: {
      "click": function($event) {
        return _vm.doRegisterUser()
      }
    }
  }, [_c('a', [_vm._v("PCや別の端末と連携する")])]) : _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPlatformiOS(_vm.platformName)),
      expression: "isPlatformiOS(platformName)"
    }],
    on: {
      "click": function($event) {
        return _vm.doUnregisterUser()
      }
    }
  }, [_c('a', [_vm._v("PCや別の端末との連携を解除する")])]), _vm._v(" "), (_vm.isPlatformiOS(_vm.platformName) || _vm.isLibraryAndroid(_vm.platformName)) ? _c('li', [_c('a', {
    staticClass: "userdell",
    attrs: {
      "href": "https://www.sourcenext.com/support/form/InquiryForm0512",
      "target": "_blank"
    }
  }, [_vm._v("アカウント削除")])]) : _vm._e()])])])], 1)])])])]), _vm._v(" "), _c('nav', {
    staticClass: "navigation",
    attrs: {
      "id": "pcNav"
    }
  }, [_c('ul', [_c('li', {
    class: {
      'current-page': _vm.$parent.currentView == 'PurchasedList' || _vm.$parent.currentView == 'PurchasedDetail'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.showLearning()
      }
    }
  }, [_vm._v("学習")])])])])]), _vm._v(" "), (!_vm.isDocomo(_vm.platformName) && !_vm.isAu(_vm.platformName)) ? _c('div', {
    staticClass: "sp-second-header"
  }, [_c('div', {
    staticClass: "items"
  }, [_c('div', [_c('div', {
    staticClass: "studylink",
    on: {
      "click": function($event) {
        return _vm.showLearning()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/icon/header/icon-study.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("学習")])])])])]) : _vm._e(), _vm._v(" "), (_vm.isLogoutVisible) ? _c('Logout', {
    on: {
      "close": function($event) {
        _vm.isLogoutVisible = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isTakeOverVisible) ? _c('TakeOver', {
    on: {
      "close": function($event) {
        return _vm.closeTakeOver()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2cda2f73", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-2cda2f73","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar.vue
// module id = 711
// module chunks = 1